
// import { useGetProspectoByIdProspecto } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { useParams } from "react-router-dom";
import AddMaterialFactibilidadCorporativoPage from "../../shared/add_solicitud_factibilidad_corporativo/AddMaterialFactibilidadCorporativoPage";
import { useFetchGetByIdfactibilidadCorporativos } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { EstadoFactibilidadCorporativaENUM, useCheckPermissions } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";

export default function ViewSolicitudFactibilidadCorporativoPage() {

  useCheckPermissions(PermissionsEnum.api_change_factibilidadcoorporativa);

  const { idfactibilidadcorporativa } = useParams();

  // const { data: dataProspecto, isLoading: isLoadingProspecto } = useGetProspectoByIdProspecto(idprospecto!);

  const { data: dataFactibilidadCorporativa, isLoading: isLoadingFactibilidadCorporativa } = useFetchGetByIdfactibilidadCorporativos(idfactibilidadcorporativa!)

  if (isLoadingFactibilidadCorporativa) return <LoaderComponent />

  if (!dataFactibilidadCorporativa) return null;

  return (
    <AddMaterialFactibilidadCorporativoPage
      title="Revisión de Factibilidad Corporativa"
      // dataProspecto={dataProspecto!}
      dataFactibilidadCorporativa={dataFactibilidadCorporativa?.data}
      dataPreventa={dataFactibilidadCorporativa?.data?.preventa_corporativa_data!}
      updateFactibilidad={true}
      showSaveButton={true}
      DISABLE_FIELD={
        dataFactibilidadCorporativa?.data?.estado_factibilidad==EstadoFactibilidadCorporativaENUM.EN_GESTION ||
        dataFactibilidadCorporativa?.data?.estado_factibilidad==EstadoFactibilidadCorporativaENUM.APROBADO ||
        dataFactibilidadCorporativa?.data?.estado_factibilidad==EstadoFactibilidadCorporativaENUM.PRE_RECHAZADO ||
        dataFactibilidadCorporativa?.data?.estado_factibilidad==EstadoFactibilidadCorporativaENUM.CANCELADO ||
        dataFactibilidadCorporativa?.data?.estado_factibilidad==EstadoFactibilidadCorporativaENUM.EN_INSPECCION 
      }
    />
  );

}